import template from './mentor.template.html';

export default {
  template,
  bindings: {
    formName: '<',
    isReadyForVerification: '<',
    isVerified: '<',
    isDealOwnerMentee: '<',
    isDealOwnerHasMentor: '<',
    isTicketSettled: '<',
    onFinished: '&'
  },
controller: class controller {
    constructor(
      $rootScope,
      $mdUtil,
      $mdMedia,
      helperService,
      ticketService,
      TicketStatusHistory
    ) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.mdMedia = $mdMedia;
      ctrl.currentOrganization = $rootScope.CurrentOrganization;
      ctrl.currentDateFormat = $rootScope.CurrentDateFormatPrimary();
      ctrl.currentCurrency = $rootScope.CurrentCurrency();
      ctrl.organizationCountry = '';
      ctrl.isReady = false;

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      ctrl.initialize = () => {
        ctrl.organizationCountry = helperService.getOrganizationCountry().name;
        ctrl.isReadyForVerification = ctrl.isReadyForVerification || false;
        ctrl.isVerified = ctrl.isVerified || false;
        ctrl.isDealOwnerMentee = ctrl.isDealOwnerMentee || false;
        ctrl.isDealOwnerHasMentor = ctrl.isDealOwnerHasMentor || false;
        ctrl.isTicketSettled = ctrl.isTicketSettled || false;
        ctrl.isReady = true;
      };

      ctrl.ticketStatusChange = (status) => {
        ticketService.ticketStatusChange(status).then((data) => {
          if (data && !_.isEmpty(data) && data instanceof TicketStatusHistory) {
            ctrl.saveTicketStatusHistory(data);
          }
        });
      };

      /*
       * Save ticket status history
       * --------------------------------------------------------------------------------
       */
      ctrl.saveTicketStatusHistory = $mdUtil.debounce((statusHistory) => {
        ctrl.onFinished({ statusHistory });
      }, 1500);

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      ctrl.$onInit = () => {
        ctrl.initialize();
      };
    }
  }
};
